import React from 'react'
import { useTranslation } from 'react-i18next'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import { receiptTypeEnum } from 'libraries/utils'

const ReceiptInfoTable = props => {
	const { t } = useTranslation();
	const { data } = props
	return (
		<Table>
            <TableHead>
                <TableRow>
					<TableCell style={{paddingLeft: '30px'}}>{t('invoice_type')}</TableCell>
                    <TableCell>{t('receipt_title')}</TableCell>
                    <TableCell>{t('tax_id')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell style={{paddingLeft: '30px'}}>{receiptTypeEnum[data.getIn(['receipt','type'])]}</TableCell>
                    <TableCell>{data.getIn(['receipt', 'title'])}</TableCell>
                    <TableCell>{data.getIn(['receipt', 'taxId'])}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
	)
}

export default ReceiptInfoTable
